import { axios } from 'lib/axios';
import { useQuery } from 'react-query';

export const getManual = () => {
  return axios.get('/emis-manual');
};

export const useGetManual = ({ config } = {}) => {
  return useQuery({
    ...config,
    queryKey: ['emisManual'],
    queryFn: () => getManual(),
  });
};
